/** Plan display: DB stores price in dollars (e.g. 9.99). */
export function formatMoney2(n) {
  const x = Number(n);
  if (Number.isNaN(x)) return '0.00';
  return x.toFixed(2);
}

export function parseStrikeAmount(s) {
  if (s == null || s === '') return null;
  const x = parseFloat(String(s).replace(/,/g, ''));
  return Number.isFinite(x) && x > 0 ? x : null;
}
